import './styles/main.scss';
import {BrowserRouter, Route, Routes} from 'react-router-dom';
import {useMemo, useState} from "react";
import InstallPage from "./pages/InstallPage";
import Loading from "./elements/Loading";
import NoSettingsPage from "./pages/NoSettings";

function App() {
    const [appInitialized, setAppInitialized] = useState(false)

    const BX24 = useMemo(() => {
        // Для страницы авторизации hh.ru вне битрикса
        if (!window.location.pathname.includes('install')) {
            console.log('bx excluded')
            setAppInitialized(true)
            return
        }
        const bx = window.BX24
        bx.init(() => setAppInitialized(true));
        return bx;
    }, [])

    if (!appInitialized) {
        return <Loading isLoading={true}/>
    }
    return (
        <BrowserRouter>
            <Routes>
                <Route exact path="/install" element={<InstallPage BX24={BX24}/>}/>
                <Route exact path="/no-setting" element={<NoSettingsPage/>}/>
            </Routes>
        </BrowserRouter>
    )

}

export default App;
